export type I18Lang = string;

// Paths to modules with `lang` folder
export const I18N_NAMESPACE = {
  PREMATCH: 'Prematch/lang',
} as const;

// ---

export const SUPPORTED_LANGS = [
  'ru',
  'en',
  'uz',
  'kk',
  'ky',
  // 'tg',
] as const;

export const FALLBACK_LANG = SUPPORTED_LANGS[0];

export type SupportedLang = (typeof SUPPORTED_LANGS)[number];


export type AllowedCountries = 'RU' | 'KG' | 'KZ' | 'TJ' | 'UZ';

// ---

export const LANG_TITLE_BY_CODE: Record<SupportedLang, string> = {
  ru: 'Русский',
  en: 'English',
  uz: 'O\'zbekcha',
  kk: 'Қазақ',
  ky: 'Кыргыз тили',
  // tg: 'Тоҷикӣ',
};
